import React, { forwardRef } from 'react';

import MUISelect, {
  SelectProps as MUISelectProps,
} from '@material-ui/core/Select';

import { useMUITheme } from '../styles/theme';
import { Icons } from '../Icon';

import { useMenuStyles } from './styles';

export interface SelectProps extends MUISelectProps {}

const Select = forwardRef<HTMLDivElement, SelectProps>((props, ref) => {
  const theme = useMUITheme();
  const { root: menuRoot } = useMenuStyles();

  const {
    MenuProps = {
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left',
      },
      transformOrigin: {
        vertical: -theme.spacing(1),
        horizontal: 'left',
      },
      getContentAnchorEl: null,
      classes: {
        paper: menuRoot,
      },
    },
    ...rest
  } = props;

  return (
    <MUISelect
      {...rest}
      ref={ref}
      IconComponent={Icons.KeyboardArrowDown}
      MenuProps={MenuProps}
    >
      {props.children}
    </MUISelect>
  );
});

Select.displayName = 'Select';

export default Select;
